<template>
  <div role="main" class="content">
    <p class="mt-2 mb-3" style="font-size: 1.75rem;" tabindex="0">
      {{ $t("pointsTitle") }}
    </p>
    <b-row class="justify-content-center points">
      <b-col class="col-11 col-md-4">
        <b-form-group
          id="fieldset-1"
          :label="$t('pointsLocalityLabel')"
          label-for="locality-input"
        >
          <b-form-input
            id="locality-input"
            list="localities"
            @change="changeLocalisty"
            autocomplete="off"
            ref="localitiesRef"
            role="search"
          >
          </b-form-input>

          <datalist id="localities">
            <option v-for="locality in localities" :key="locality">{{
              locality
            }}</option>
          </datalist>
        </b-form-group>
        <!-- <v-autocomplete
          :label="$t('pointsLocalityLabel')"
          outlined
          clearable
          :items="locality"
          autocomplete="off"
          v-model="localitySelected"
        ></v-autocomplete> -->
      </b-col>
      <b-col class="col-11 col-md-4">
        <b-form-group
          id="fieldset-1"
          :label="$t('pointsAddressLabel')"
          label-for="address-input"
        >
          <b-form-input
            id="address-input"
            list="address"
            @change="changeAddress"
            autocomplete="off"
            ref="addressRef"
            role="search"
          >
          </b-form-input>

          <datalist id="address">
            <option v-for="addr in addressFiltered" :key="addr">
              {{ addr }}
            </option>
          </datalist>
        </b-form-group>
        <!-- <v-combobox :label="$t('pointsAddressLabel')" outlined clearable autocomplete="off" :items="addressFiltered" v-model="addressSet" hide-no-data></v-combobox> -->
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <b-button
          variant="primary"
          :disabled="resetDisabled"
          @click="resetFields"
          >{{ $t("resetBtn") }}</b-button
        >
      </b-col>
    </b-row>
    <b-container class="mb-3">
      <b-table
        striped
        hover
        :items="pointsFiltered"
        selectable
        responsive
      ></b-table>
      <!-- <v-simple-table class="mb-3">
        <thead>
          <tr>
            <th class="text-left" tabindex="0">{{ $t("pointsName") }}</th>
            <th class="text-left" tabindex="0">{{ $t("pointsCity") }}</th>
            <th class="text-left" tabindex="0">{{ $t("pointsAddress") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in pointsFiltered" :key="index">
            <td class="text-left" tabindex="0">{{ item.name }}</td>
            <td class="text-left" tabindex="0">{{ item.city }}</td>
            <td class="text-left" tabindex="0">{{ item.address }}</td>
          </tr>
        </tbody>
      </v-simple-table> -->
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      localities: null,
      localityRu: null,
      localityEn: null,
      address: null,
      addressFiltered: null,
      addressRu: null,
      addressEn: null,
      localitySelected: null,
      addressSet: null,
      pointsFiltered: [],
      points: null,
      fields: ["pointsName", "pointsCity", "pointsAddress"]
      // type: Object,
      // defaults: {
      //   name: "",
      //   city: "",
      //   address: ""
      // }
      // }
    };
  },
  created() {
    this.points = JSON.parse(localStorage.getItem("points"));
    this.localityRu = [
      ...new Set(
        this.points
          .filter(p => {
            return p.city_ru !== "";
          })
          .map(p => {
            return p.city_ru;
          })
      )
    ];
    this.localityEn = [
      ...new Set(
        this.points
          .filter(p => {
            return p.city_en !== "";
          })
          .map(p => {
            return p.city_en;
          })
      )
    ];
    this.addressRu = [
      ...new Set(
        this.points
          .filter(p => {
            return p.address_ru !== "";
          })
          .map(p => {
            return p.address_ru;
          })
      )
    ];
    this.addressEn = [
      ...new Set(
        this.points
          .filter(p => {
            return p.address_en !== "";
          })
          .map(p => {
            return p.address_en;
          })
      )
    ];
    if (this.$i18n.locale === "ru") {
      this.localities = this.localityRu;
      this.address = this.addressRu;
      this.addressFiltered = this.addressRu;
    } else {
      this.localities = this.localityEn;
      this.address = this.addressEn;
      this.addressFiltered = this.addressEn;
    }
  },
  methods: {
    filterPointsByCity() {
      if (this.$i18n.locale === "ru") {
        this.pointsFiltered = this.points
          .filter(p => {
            return p.city_ru
              .toLowerCase()
              .includes(this.localitySelected.toLowerCase());
          })
          .map(p => {
            return {
              Название: p.ru,
              Город: p.city_ru,
              Адрес: p.address_ru
            };
          });
      } else {
        this.pointsFiltered = this.points
          .filter(p => {
            return p.city_en
              .toLowerCase()
              .includes(this.localitySelected.toLowerCase());
          })
          .map(p => {
            return {
              name: p.en,
              city: p.city_en,
              address: p.address_en
            };
          });
      }
    },
    filterPointsByAddress(address) {
      if (this.$i18n.locale === "ru") {
        this.pointsFiltered = this.points
          .filter(p => {
            return p.address_ru.toLowerCase().includes(address);
          })
          .map(p => {
            return {
              Название: p.ru,
              Город: p.city_ru,
              Адрес: p.address_ru
            };
          });
      } else {
        this.pointsFiltered = this.points
          .filter(p => {
            return p.address_en.toLowerCase().includes(address);
          })
          .map(p => {
            return {
              name: p.en,
              city: p.city_en,
              address: p.address_en
            };
          });
      }
    },
    changeLocalisty(value) {
      this.localitySelected = value;
      this.$nextTick(function() {
        this.$refs.addressRef.$refs.input.value = "";
      });
    },
    changeAddress(value) {
      this.addressSet = value;
    },
    resetFields() {
      // this.$refs.localitiesRef.$refs.input.value = "";
      this.pointsFiltered = [];
      this.localitySelected = "";
      this.addressSet = "";
      this.$nextTick(function() {
        this.$refs.localitiesRef.$refs.input.value = "";
        this.$refs.addressRef.$refs.input.value = "";
      });
    }
  },
  computed: {
    resetDisabled() {
      if (this.localitySelected || this.addressSet) {
        return false;
      }
      return true;
    }
  },
  watch: {
    "$i18n.locale": {
      handler(val) {
        if (val === "ru") {
          this.localities = this.localityRu;
          this.address = this.addressRu;
          this.addressFiltered = this.addressRu;
        } else {
          this.localities = this.localityEn;
          this.address = this.addressEn;
          this.addressFiltered = this.addressEn;
        }
        // this.locality = this.localityRu;
      }
    },
    localitySelected: {
      handler(val) {
        if (val && val !== "") {
          this.addressFiltered = this.address.filter(a => {
            return a.includes(val);
          });
          this.filterPointsByCity();
        } else {
          this.addressFiltered = this.address;
          this.pointsFiltered = [];
        }
      }
    },
    addressSet: {
      handler(val) {
        if (val && val !== "") {
          this.addressFiltered = this.address.filter(a => {
            return a.includes(val);
          });
          this.filterPointsByAddress(val.toLowerCase());
        } else {
          this.addressFiltered = this.address;
          if (this.localitySelected && this.localitySelected !== "") {
            this.filterPointsByCity();
          } else {
            this.pointsFiltered = [];
          }
        }
      }
    }
  }
};
</script>

<style scoped>
.content {
  flex: 1;
  /* min-height: 90vh; */
}
.v-select-list {
  text-align: left;
}

.form-clear {
  align-items: center;
  background: #cecece;
  border-radius: 50%;
  bottom: 8px;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  display: flex;
  height: 24px;
  justify-content: center;
  position: absolute;
  right: 0;
  width: 24px;
  z-index: 10;
}

.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>
